module.exports = __webpack_public_path__ + "void-65dfe5bd31335a5b308d36964d320574.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/void.png
// module id = 283
// module chunks = 86